/***
 * Collection of Connect TimeZones.
 */
import Backbone from 'backbone';

import TimeZone from 'models/activity/TimeZone';

var TimeZones = Backbone.Collection.extend({
    model: TimeZone,

    backend: 'gcapi',

    url: function() {
        return '/system-service/timezoneUnits';
    },

    initialize: function() {},

    comparator: function(a, b) {
        var gmtOffsetA = a.get('gmtOffset');
        var gmtOffsetB = b.get('gmtOffset');
        if (gmtOffsetA > gmtOffsetB) {
            return 1;
        } else if (gmtOffsetA < gmtOffsetB) {
            return -1;
        } else {
            return 0;
        }
    },

    getByKey: function(key) {
        return this.find(function(timeZone) {
            return timeZone.get('unitKey') === key;
        });
    }
});

export default new TimeZones([]);
